import { render, staticRenderFns } from "./PlacementsEndComponentReview.vue?vue&type=template&id=261d2d07&"
import script from "./PlacementsEndComponentReview.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports